import request from '@/utils/request'
/**
 * @apiName 租赁方案绑定记录分页列表
 * @param  data {itemType:项目类型 0套餐/1单品,maintenanceType:维保类型 0保养/1维修,storeId:适用维修厂ID,
 * collaborationId:本地合作关系ID,serviceId:本地服务商ID,rentPlanId:租赁方案ID,rentPlanType:租赁方案类型 1个人/2企业}
 * @returns
 */
export function maintenanceOrderBindListApi(data = {}) {
  return request({
    url: '/admin/v1/maintenance/orderLink/pageList',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 租赁方案名称模糊查询
 * @param  data {name:名称,rentPlanType:租赁方案类型  1 "个人租赁方案"  2 "企业租赁方案",allFlag}
 * @returns
 */
export function getRentPlanNamesApi(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/plan/likeByName',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 车辆品牌列表
 * @returns
 */

export function getCarbrandListApi(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/model/brandList',
    method: 'POST',
    data,
  })
}

//

/**
 * @apiName 车系列表
 * @returns
 */

export function getCarSeriesListApi(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/model/seriesList',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 车牌号
 * @returns
 */

export function getCarPlateNoApi(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carLicenseManage/likeByPlateNo',
    method: 'POST',
    data,
  })
}


/**
 * @apiName vin
 * @returns
 */

export function getCarVinApi(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carLicenseManage/likeByVin',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 重新创建维保订单
 * @params {id:绑定记录ID}
 */

export function recreateOrderLinkAPi(data = {}) {
  return request({
    url: '/admin/v1/maintenance/orderLink/recreate',
    method: 'POST',
    data,
  })
}


// 根据车牌号查询车辆id plateNo
export function getCarInfoApi(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/getCarInfo',
    method: 'POST',
    data,
  })
}


/**
 * @apiName vin码模糊查询 最多返回100条
 * @params {name:名称}
 */
export function carLicenseManageLikeByVinApi(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carLicenseManage/likeByVin',
    method: 'POST',
    data,
  })
}
